import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteData, getData, getDataById, postData, postDataWithParams, updateData } from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  updatedTime:0,
  isLoading: true,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getPriceType = createAsyncThunk(
  "admin/priceType",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData("/master/price-type", data.token, data.params);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getPriceTypeById = createAsyncThunk(
  "admin/priceType/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById("/master/price-type/", data.token, data.id);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortPriceType = createAsyncThunk(
  "admin/priceType/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/master/price-type/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const postPriceType = createAsyncThunk(
  "admin/priceType/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData("/master/price-type", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deletePriceType = createAsyncThunk(
  "admin/priceType/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData("/master/price-type/", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updatePriceType = createAsyncThunk(
  "admin/priceType/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/master/price-type/",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const priceTypeSlice = createSlice({
  name: "Price Type Store",
  initialState: initialState,
  reducers: {
    addPriceType(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortPriceType(state, action) {
      state.data.docs = action.payload;
    },
    deletePriceType(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editPriceType(state, action) {
      state.data.docs = state.data.docs.map((item) =>
        item._id === action.payload._id ? action.payload : item
      ); 
      state.data.docs.shift();
    },
  },
  extraReducers: {
    [getPriceType.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getPriceType.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getPriceType.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getPriceTypeById.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getPriceTypeById.fulfilled]: (state, action) => {
      state.data.docs.unshift(action.payload.data);
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getPriceTypeById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortPriceType.pending]: (state, ) => {
      state.isLoading = true;
    },
    [sortPriceType.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortPriceType.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postPriceType.pending]: (state, ) => {
      state.isLoading = true;
    },
    [postPriceType.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postPriceType.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deletePriceType.pending]: (state, ) => {
      state.isLoading = true;
    },
    [deletePriceType.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deletePriceType.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updatePriceType.pending]: (state, ) => {
      state.isLoading = true;
    },
    [updatePriceType.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updatePriceType.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
  },
});

export const priceTypeActions = priceTypeSlice.actions;

export default priceTypeSlice.reducer;
